module.exports = __webpack_public_path__ + "static/img/banner04.37d4a87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner04.jpg
// module id = t2Jh
// module chunks = 1